import { Injectable } from '@angular/core';
import {Submission} from './models/submission';
import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';

import { Observable } from "rxjs/Observable";
import { environment } from "../environments/environment";

@Injectable()
export class SubmissionService {

  private apiBase:string = environment.api_base;

  constructor(private http: HttpClient) { }

  getSubmissions(limit=30, offset=0): Observable<Submission[]> {
      return this.http.get<Submission[]>(`${this.apiBase}submissions/?limit=${limit}&offset=${offset}`)
  }

  getOtherSubmissions(author: string): Observable<Submission[]> {
      return this.http.get<Submission[]>(`${this.apiBase}submission/other/${author}`)
  }

  searchSubmissions(term: string): Observable<Submission[]>{
    let submissions = this.http.get(`${this.apiBase}submissions/?search=${term}`)
    const subs = submissions.map(sub => sub['results'] as Submission[])
    return subs
  }

  getSubmission(id: string): Promise<Submission>{
    return this.http.get<Submission>(`${this.apiBase}submission/${id}/`)
      .toPromise()
    }

  getCurrentPosts(): Observable<Submission[]>{
    return this.http.get<Submission[]>(`${this.apiBase}submissions/current/`)
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/app/submission.service.ts